import { apiSlice } from '@/store/api/apiSlice';

export interface MonthlyPredictionArgs {
  rashi: string;
}

export interface MonthlyPredictionResponse {
  prediction: string;
}

export const monthlyPredictionGetApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMonthlyPrediction: builder.query<MonthlyPredictionResponse, MonthlyPredictionArgs>({
      query: ({ rashi }) => ({
        url: 'predictions/month',
        method: 'GET',
        params: {
          rashi,
        },
      }),
    }),
  }),
});

export const { useGetMonthlyPredictionQuery, useLazyGetMonthlyPredictionQuery } =
  monthlyPredictionGetApi;
